import { Notyf } from 'notyf'
import 'notyf/notyf.min.css'

const notyf = new Notyf({
	position: {
		x: 'center',
		y: 'top',
	},
	duration: 3000,
	types: [
		{
			type: 'error',
			dismissible: true,
			duration: 30000,
		}
	]
})
export default notyf